import _implicitStylesheets from "./lightboxV2.css";
import _implicitScopedStylesheets from "./lightboxV2.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _axButton from "ax/button";
import _listingVideoPreviewV2 from "listing/videoPreviewV2";
import _axImage from "ax/image";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="backdrop${0}"${2}></div>`;
const $fragment2 = parseFragment`<div tabindex="0"${3}></div>`;
const $fragment3 = parseFragment`<iframe class="media video${0}"${"a0:title"}${"a0:src"} frameborder="0" allowtransparency="true" scrolling="no" allowfullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen" referrerpolicy="strict-origin-when-cross-origin" data-testid="lightbox-video-iframe"${2}></iframe>`;
const $fragment4 = parseFragment`<figcaption class="content__info${0}"${2}><h2${"a1:id"} type-style="body-2" class="title${0}"${2}>${"t2"}</h2><p${"a3:id"} class="lightbox-header-alt-text${0}"${2}>${"t4"}</p></figcaption>`;
const $fragment5 = parseFragment`<div class="lightbox-thumbs-scrollbar${0}" role="scrollbar"${"a0:tabindex"}${"a0:aria-label"}${"a0:aria-controls"} aria-orientation="horizontal" aria-valuemin="0" aria-valuemax="100"${"a0:aria-valuenow"}${2}><div class="lightbox-thumbs-scrollbar__thumb${0}"${2}></div></div>`;
const stc0 = {
  "lightbox": true,
  "gallery": true
};
const stc1 = {
  "back__button": true
};
const stc2 = {
  slotAssignment: "start",
  props: {
    "icon": "back",
    "spriteUrl": "/images/icons.svg",
    "size": "large",
    "ariaHidden": "true"
  },
  key: 7
};
const stc3 = {
  classMap: {
    "wrapper": true
  },
  key: 8
};
const stc4 = {
  "close__button": true
};
const stc5 = {
  classMap: {
    "close__icon": true
  },
  props: {
    "icon": "close",
    "spriteUrl": "/images/icons.svg",
    "size": "large",
    "ariaHidden": "true"
  },
  key: 10
};
const stc6 = {
  classMap: {
    "content": true
  },
  key: 11
};
const stc7 = {
  classMap: {
    "lightbox-figure": true
  },
  key: 12
};
const stc8 = {
  classMap: {
    "media-frame": true
  },
  key: 13
};
const stc9 = {
  "video-play-trigger": true,
  "video": true
};
const stc10 = {
  "gallery-media": true
};
const stc11 = {
  "data-testid": "lightbox-img"
};
const stc12 = {
  "forward__button": true
};
const stc13 = {
  slotAssignment: "end",
  props: {
    "icon": "forward",
    "spriteUrl": "/images/icons.svg",
    "size": "large",
    "ariaHidden": "true"
  },
  key: 22
};
const stc14 = {
  classMap: {
    "lightbox-thumbs-rail": true
  },
  key: 23
};
const stc15 = {
  "lightbox-thumbnails": true
};
const stc16 = {
  classMap: {
    "lightbox-thumbnail__play": true
  },
  key: 26
};
const stc17 = {
  props: {
    "icon": "play",
    "size": "large",
    "spriteUrl": "/images/icons.svg",
    "ariaHidden": "true"
  },
  key: 27
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, b: api_bind, sp: api_static_part, st: api_static_fragment, ncls: api_normalize_class_name, c: api_custom_element, h: api_element, d: api_dynamic_text, k: api_key, i: api_iterator, ti: api_tab_index} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": api_scoped_id("lightbox-header-alt-text")
    },
    key: 0,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.handleKeyDown))
    }
  }, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.close))
    }
  }, null)]), api_static_fragment($fragment2, 4, [api_static_part(0, {
    on: {
      "focus": _m4 || ($ctx._m4 = api_bind($cmp.handleModalInteractionLoopFocus))
    }
  }, null)]), $cmp._currentItem ? api_element("div", {
    className: api_normalize_class_name($cmp.containerClass),
    key: 5
  }, [$cmp.enableControls ? api_custom_element("ax-button", _axButton, {
    classMap: stc1,
    props: {
      "variant": "secondary",
      "ariaLabel": $cmp.labels.back
    },
    key: 6,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.showPreviousItem))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc2)]) : null, api_element("div", stc3, [api_element("button", {
    classMap: stc4,
    attrs: {
      "aria-label": $cmp.labels.close
    },
    key: 9,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.close))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc5)]), api_element("div", stc6, [api_element("figure", stc7, [api_element("div", stc8, [$cmp.showVideo ? !$cmp.isVideoPlaying ? api_element("button", {
    classMap: stc9,
    attrs: {
      "type": "button",
      "aria-label": $cmp.playVideoLabel,
      "data-testid": "lightbox-play-video"
    },
    key: 14,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.handlePlayVideo))
    }
  }, [api_custom_element("listing-video-preview-v2", _listingVideoPreviewV2, {
    props: {
      "posterSrc": $cmp.thumb,
      "altText": $cmp.altText
    },
    key: 15
  })]) : null : null, $cmp.showVideo ? $cmp.isVideoPlaying ? api_static_fragment($fragment3, 17, [api_static_part(0, {
    attrs: {
      "title": $cmp.altText,
      "src": $cmp.src
    }
  }, null)]) : null : null, !$cmp.showVideo ? api_custom_element("ax-image", _axImage, {
    classMap: stc10,
    attrs: stc11,
    props: {
      "imgSrc": $cmp.src,
      "alt": $cmp.altText,
      "width": "100%",
      "height": "100%"
    },
    key: 18
  }) : null]), api_static_fragment($fragment4, 20, [api_static_part(1, {
    attrs: {
      "id": api_scoped_id("lightbox-header")
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.caption)), api_static_part(3, {
    attrs: {
      "id": api_scoped_id("lightbox-header-alt-text")
    }
  }, null), api_static_part(4, null, api_dynamic_text($cmp.altText))])])])]), $cmp.enableControls ? api_custom_element("ax-button", _axButton, {
    classMap: stc12,
    props: {
      "variant": "secondary",
      "ariaLabel": $cmp.labels.forward
    },
    key: 21,
    on: {
      "click": _m8 || ($ctx._m8 = api_bind($cmp.showNextItem))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc13)]) : null, $cmp.enableControls ? api_element("div", stc14, [api_element("div", {
    classMap: stc15,
    attrs: {
      "id": api_scoped_id("lightbox-thumbnails")
    },
    key: 24,
    on: {
      "scroll": _m9 || ($ctx._m9 = api_bind($cmp.handleThumbnailScroll))
    }
  }, api_iterator($cmp.thumbnailItems, function (thumbnail) {
    return api_element("button", {
      className: api_normalize_class_name(thumbnail.thumbnailClass),
      attrs: {
        "data-index": thumbnail.arrayIndex,
        "aria-label": thumbnail.ariaLabel,
        "aria-current": thumbnail.isSelected
      },
      key: api_key(25, thumbnail.position),
      on: {
        "click": _m10 || ($ctx._m10 = api_bind($cmp.selectThumbnail))
      }
    }, [thumbnail.isVideo ? api_element("div", stc16, [api_custom_element("ax-icon", _axIcon, stc17)]) : null, api_custom_element("ax-image", _axImage, {
      props: {
        "imgSrc": thumbnail.thumb,
        "alt": ""
      },
      key: 28
    })]);
  })), api_static_fragment($fragment5, 30, [api_static_part(0, {
    on: {
      "keydown": _m13 || ($ctx._m13 = api_bind($cmp.handleScrollbarKeyDown)),
      "mousedown": _m14 || ($ctx._m14 = api_bind($cmp.startThumbScroll))
    },
    attrs: {
      "tabindex": api_tab_index($cmp.scrollbarTabIndex),
      "aria-label": $cmp.labels.lightboxThumbnailScrollbarLabel,
      "aria-controls": api_scoped_id("lightbox-thumbnails"),
      "aria-valuenow": $cmp.scrollbarValue
    }
  }, null)])]) : null]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7rtndjj6sdg";
tmpl.legacyStylesheetToken = "undefined-_lightboxV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
